'use client';

import { CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './AdvancedMetricsModal.module.css';

export const AdvancedMetricsModal = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const { width } = useWindowSize();

  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      role="button"
      tabIndex={0}
      aria-labelledby="advanced-metrics-modal-heading"
    >
      <div className="container">
        <h4 id="advanced-metrics-modal-heading">
          {t('ring.bentoSleepSection.advancedMetricsCard.modal.head')}
        </h4>
        <h3>{t('ring.bentoSleepSection.advancedMetricsCard.modal.subHead')}</h3>
        <p className="description">
          {t('ring.bentoSleepSection.advancedMetricsCard.modal.description')}
        </p>
        <div className="modal-items">
          <div className="item">
            <h5>
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardA.title')}{' '}
            </h5>
            <p className="text-mid">
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardA.descA')}{' '}
              <span className="thin">
                {t(
                  'ring.bentoSleepSection.advancedMetricsCard.modal.cardA.descThin',
                )}
              </span>{' '}
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardA.descB')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t('advancedMetricsModal.content.ariaLabel')}
            >
              {width > 992 ? (
                <Image
                  src={
                    'web_v2/ring-buy/sleep/png/flip/advancedMetricsFlipAlg.png'
                  }
                  fill
                  alt=""
                  className="sleep-index"
                  aria-hidden="true"
                />
              ) : (
                <Image
                  src={'web_v2/ring-buy/sleep/png/flip/metricsFlipAresp.png'}
                  fill
                  alt=""
                  className="sleep-index"
                  aria-hidden="true"
                />
              )}
            </div>
          </div>
          <div
            className="item"
            style={
              {
                '--item-bg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/flip/metricsFlipBresp.png',
                )})`,
                '--item-bg-lg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/flip/advancedMetricsFlipBlg.png',
                )})`,
              } as CSSProperties
            }
          >
            <h5>
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardB.title')}
            </h5>
            <p className="text-mid">
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardB.desc')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t('advancedMetricsModal.content.ariaLabel2')}
            >
              {width > 992 ? (
                <Image
                  src={
                    'web_v2/ring-buy/sleep/svg/flip/advancedMetricsFlipC.svg'
                  }
                  fill
                  alt=""
                  className="advanced-metrics-morning-alertness"
                  aria-hidden="true"
                />
              ) : null}
            </div>
          </div>
          <div
            className="item"
            style={
              {
                '--item-bg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/flip/metricsFlipCresp.png',
                )})`,
                '--item-bg-lg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/sleep/png/flip/advancedMetricsFlipDlg.png',
                )})`,
              } as CSSProperties
            }
          >
            <h5>
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardC.title')}
            </h5>
            <p className={width > 992 ? 'text-right' : 'text-mid'}>
              {t('ring.bentoSleepSection.advancedMetricsCard.modal.cardC.desc')}
            </p>
            <div
              className="img-container"
              role="img"
              aria-label={t('advancedMetricsModal.content.ariaLabel3')}
            >
              {width > 992 ? (
                <Image
                  src={
                    'web_v2/ring-buy/sleep/svg/flip/advancedMetricsFlipE.svg'
                  }
                  fill
                  alt=""
                  className="advanced-metrics-morning-alertness"
                  aria-hidden="true"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
